import { render, staticRenderFns } from "./WalletSummary.vue?vue&type=template&id=e84109c2&"
import script from "./WalletSummary.vue?vue&type=script&lang=js&"
export * from "./WalletSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports